import React, { useEffect, useState } from "react";
import axios from "axios";
import CommonReportLayout from "./CommonReportLayout";
import { REACT_APP_API_URL } from "../../../../env";

const UnitStockReport = () => {
  const [data, setData] = useState([]);

  const [selectType, setSelectType] = useState("");
  const [itemCategory, setItemCategory] = useState("");
  const [itemSubCategory, setItemSubCategory] = useState("");

  const [typeList, setTypeList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadInitialData();
  }, []);

  // ===============================
  // Load Category + Static Type
  // ===============================
  const loadInitialData = async () => {
    try {
      setTypeList([
        { label: "Head Office", value: "1" },
        { label: "TIC", value: "2" },
        { label: "Hotel", value: "3" }
      ]);

      const res = await axios.post(
        `${REACT_APP_API_URL}api/inventory-report/category`,
        {}
      );

      setCategoryList(res.data || []);
    } catch (error) {
      console.log("Category Load Error:", error);
    }
  };

  // ===============================
  // Load SubCategory
  // ===============================
  const loadSubCategory = async (categoryId) => {
    try {
      setSubCategoryList([]);

      const res = await axios.post(
        `${REACT_APP_API_URL}api/inventory-report/subcategory`,
        {
          categoryId: Number(categoryId)
        }
        
      );

      setSubCategoryList(res.data || []);
    } catch (error) {
      console.log("SubCategory Load Error:", error);
    }
  };

  // ===============================
  // Category Change
  // ===============================
  const handleCategoryChange = (e) => {
  const value = e.target.value;

  setItemCategory(value);
  setItemSubCategory("");

  if (value) {
    loadSubCategory(value);
  } else {
    setSubCategoryList([]);
  }
};

  // ===============================
  // Show Report
  // ===============================
  const fetchData = async () => {
  try {
    setLoading(true);

    const payload = {
      categoryId: Number(itemCategory || 0),
      subCategoryId: Number(itemSubCategory || 0),
      hoId: Number(selectType || 0),
      ticId: 0,
      hotelId: 0,
      pageNo: 0,
      pageSize: 0
    };

    const res = await axios.post(
      `${REACT_APP_API_URL}api/inventory-report/unit-stock`,
      payload
    );

    setData(res.data);

  } catch (error) {
    console.log(error);
    setData([]);
  } finally {
    setLoading(false);
  }
};

  return (
    <>
      <div className="col-sm-12 mb-3">
        <h3 className="fw-bold px-lg-4">Unit Wise Stock Details</h3>
      </div>

      <CommonReportLayout
        title="Report"
        onShow={fetchData}
        filters={
          <>
            {/* Select Type */}
            <div className="col-md-3">
              <label>Select Type</label>
              <select
                className="form-control"
                value={selectType}
                onChange={(e) => setSelectType(e.target.value)}
              >
                <option value="">-- All --</option>

                {typeList.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Category */}
            <div className="col-md-3">
              <label>Item Category</label>
              <select
                className="form-control"
                value={itemCategory}
                onChange={handleCategoryChange}
              >
                <option value="">-- All --</option>

                {categoryList.map((item, index) => (
                  <option
                    key={index}
                    value={item.ItemCategoryId}
                  >
                    {item.ItemCategoryName}
                  </option>
                ))}
              </select>
            </div>

            {/* Sub Category */}
            <div className="col-md-3">
              <label>Item Sub Category</label>
              <select
                className="form-control"
                value={itemSubCategory}
                onChange={(e) =>
                  setItemSubCategory(e.target.value)
                }
              >
                <option value="">-- All --</option>

                {subCategoryList.map((item, index) => (
                  <option
                    key={index}
                    value={item.ItemSubCategoryId}
                  >
                    {item.ItemSubCategoryName}
                  </option>
                ))}
              </select>
            </div>
          </>
        }
      >
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Sl#</th>
              <th>Type</th>
              <th>Name</th>
              <th>Location</th>
              <th>Item Category</th>
              <th>Item Subcategory</th>
              <th>Item Name</th>
              <th>Purchase Date</th>
              <th>Serial No.</th>
              <th>Invoice No.</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="10" className="text-center">
                  Loading...
                </td>
              </tr>
            ) : data.length > 0 ? (
              data.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.OrderBy}</td>
                  <td>{item.Name}</td>
                  <td>{item.LocationName}</td>
                  <td>{item.ItemCategoryName}</td>
                  <td>{item.ItemSubCategoryName}</td>
                  <td>{item.ItemName}</td>
                  <td>{item.PurchaseDate}</td>
                  <td>{item.SerialNo}</td>
                  <td>{item.InvoiceNo}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10" className="text-center">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </CommonReportLayout>
    </>
  );
};

export default UnitStockReport;